import React from "react"

import ReactMarkdown from "react-markdown"
import rehypeHighlight from "rehype-highlight"


const Markdown = ({ text, children, ...extraProps }) => {
  const rehypePlugins = [ rehypeHighlight ]

  return (
    <ReactMarkdown
      rehypePlugins={rehypePlugins}
      {...extraProps}
    >
      {text || children}
    </ReactMarkdown>
  )
}

export default Markdown
